import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Route, useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { checkUserType } from "../userUtils"
import { STAFF } from "../../commons/userTypes"
import AppConfig from "../../config/index"

const LoggedOutRoute = ({ component, childProps, ...rest }) => {
  const history = useHistory()
  const isLoggedIn = useSelector((state) => state.auth.loggedIn)
  const user = useSelector((state) => state.auth.user)
  const pagesInfos = useSelector((state) => state.pages?.pagesInfos)
  // Sonar lists 'Component' as unused. This is a false positive and is fixed in Sonar 8.5.
  const Component = component

  useEffect(() => {
    const getDefaultPath = () => {
      const allPagesHidden =
        Boolean(pagesInfos) &&
        Object.values(pagesInfos).every((page) => page.isHidden)

      if (checkUserType(user, STAFF)) {
        return "/admin"
      }
      if (AppConfig.showWealthPage && !allPagesHidden) {
        return "/wealth"
      }
      if (AppConfig.showAssetManagementPage) {
        return "/am"
      }
      return "/documents"
    }

    if (isLoggedIn) {
      // set the current url/path for future redirection (we use a Redux action)
      // then redirect (we use a React Router method)
      const defaultRedirectPath = getDefaultPath()
      history.push(defaultRedirectPath)
    }
    // TODO: Cleanup function
    return () => ({})
  }, [history, isLoggedIn, pagesInfos, user])

  if (isLoggedIn) {
    return <></>
  }

  return (
    <Route
      {...rest}
      render={(routeProps) => <Component {...routeProps} {...childProps} />}
    />
  )
}

LoggedOutRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  childProps: PropTypes.object
}

LoggedOutRoute.defaultProps = {
  childProps: {}
}

export default LoggedOutRoute
